import { memo } from 'react';
import { Link } from 'react-router-dom';
import { Music } from 'lucide-react';

/**
 * Seção "Música da Sorte" na Home.
 * Visual minimalista e integrado à página: sem glows, glassmorphism ou
 * elementos flutuantes. A composição prioriza respiro, hierarquia tipográfica
 * e o roxo da marca aplicado de forma sutil.
 */
const MusicaDaSorteCard = memo(() => {
  return (
    <section className="py-20 sm:py-24">
      <div className="container mx-auto px-4 sm:px-6">
        <Link
          to="/musica-da-sorte"
          className="group block max-w-4xl mx-auto rounded-2xl border border-white/[0.04] bg-[hsl(280,18%,7%)] transition-colors duration-300 hover:border-white/[0.08] hover:bg-[hsl(280,18%,8%)]"
        >
          <div className="flex flex-col sm:flex-row items-center justify-between gap-6 sm:gap-8 px-6 sm:px-10 py-7 sm:py-8">
            {/* Ícone + texto */}
            <div className="flex flex-col sm:flex-row items-center gap-5 sm:gap-6 text-center sm:text-left">
              <div className="shrink-0 flex items-center justify-center w-12 h-12 rounded-xl border border-white/[0.06] bg-white/[0.02] text-[hsl(280,35%,55%)] transition-colors duration-300 group-hover:border-white/[0.10] group-hover:bg-white/[0.03]">
                <Music className="w-5 h-5" strokeWidth={1.75} />
              </div>

              <div>
                <h3 className="text-xl sm:text-2xl font-semibold text-white tracking-wide">
                  Música da Sorte
                </h3>
                <p className="mt-1 text-sm sm:text-base text-white/50 leading-relaxed">
                  Descubra qual música do Bailão foi escolhida para você hoje.
                </p>
              </div>
            </div>

            {/* CTA */}
            <span className="shrink-0 inline-flex items-center justify-center px-6 py-2.5 rounded-lg bg-[hsl(280,35%,22%)] text-white text-sm font-medium transition-colors duration-300 group-hover:bg-[hsl(280,35%,28%)]">
              Sortear minha música
            </span>
          </div>
        </Link>
      </div>
    </section>
  );
});

MusicaDaSorteCard.displayName = 'MusicaDaSorteCard';
export default MusicaDaSorteCard;
